import React, { useEffect, useState } from 'react';
import StockTicker from '../components/StockTicker';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import MissionVision from '../components/MissionVision';
import Services from '../components/Services';
import CompanyNewsSection from '../components/CompanyNewsSection';
import Footer from '../components/Footer';
import {
  FeaturedVideoBlock,
  ImageStripBlock,
  TextBlockBlock,
  CtaBannerBlock,
} from '../components/HomeBlocks';
import { getHomeLayout } from '../services/api';

const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-[#e2ede6]">
    <StockTicker />
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

const BUILT_IN = {
  hero: Hero,
  stats: Stats,
  mission_vision: MissionVision,
  services: Services,
  newsroom: CompanyNewsSection,
};

const CUSTOM = {
  text_block: TextBlockBlock,
  featured_video: FeaturedVideoBlock,
  image_strip: ImageStripBlock,
  cta_banner: CtaBannerBlock,
};

const DEFAULT_ORDER = [
  { id: 'hero', type: 'hero', enabled: true },
  { id: 'stats', type: 'stats', enabled: true },
  { id: 'mission_vision', type: 'mission_vision', enabled: true },
  { id: 'services', type: 'services', enabled: true },
  { id: 'newsroom', type: 'newsroom', enabled: true },
];

const Home = () => {
  const [sections, setSections] = useState(DEFAULT_ORDER);

  useEffect(() => {
    getHomeLayout()
      .then((data) => setSections(data.sections || DEFAULT_ORDER))
      .catch(() => setSections(DEFAULT_ORDER));
  }, []);

  return (
    <Layout>
      {sections
        .filter((s) => s.enabled !== false)
        .map((s) => {
          const Built = BUILT_IN[s.type];
          if (Built) return <Built key={s.id} />;
          const Custom = CUSTOM[s.type];
          if (Custom) return <Custom key={s.id} config={s.config || {}} />;
          return null;
        })}
    </Layout>
  );
};

export { Layout };
export default Home;
